import { getIsUngatedForUniversalThemeEditing } from '../selectors/authSelectors';
export const stateSelectorSwitcher = (state, stateKey) => {
  //handle data from CEUI
  if (getIsUngatedForUniversalThemeEditing(state) && state.universalTheme) {
    // app state is available in universalTheme and saved under a different key name `themePreviewApp`
    if (stateKey === 'app') {
      return state.universalTheme.themePreviewApp;
    }
    // theme state is available in universalTheme
    if (stateKey === 'theme') {
      return state.universalTheme.theme;
    }
    // all other keys are retrieved from root state
    return state[stateKey];
  }

  //handle data from Editor 2.0 theme style plugin
  if (state['plugin-theme-styles']) {
    // data stored in namespaced plugin object
    return state['plugin-theme-styles'][stateKey];
  }

  //handle data from theme editor app
  return state[stateKey];
};